import { ref, watch } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { useMapGetter } from 'dashboard/composables/store';

const MAX_RECENT = 5;

export function applyRecentGroups(items, recentIds, { recentLabel, allLabel }) {
  if (!recentIds.length) return items;

  const order = new Map(recentIds.map((id, index) => [Number(id), index]));
  const recent = [];
  const rest = [];

  items.forEach(item => {
    if (order.has(Number(item.id))) recent.push(item);
    else rest.push(item);
  });

  if (!recent.length) return items;

  recent.sort((a, b) => order.get(Number(a.id)) - order.get(Number(b.id)));

  return [
    ...recent.map(item => ({ ...item, group: recentLabel })),
    ...rest.map(item => ({ ...item, group: allLabel })),
  ];
}

export function useRecentPickerIds(storageKey) {
  const currentAccountId = useMapGetter('getCurrentAccountId');
  const recentIds = ref([]);

  const storagePath = () => `${storageKey}::${currentAccountId.value}`;

  const read = () => {
    const stored = LocalStorage.get(storagePath()) || [];
    return Array.isArray(stored)
      ? stored.map(Number).filter(id => Number.isFinite(id))
      : [];
  };

  const remember = id => {
    const numeric = Number(id);
    if (!Number.isFinite(numeric)) return;

    recentIds.value = [
      numeric,
      ...recentIds.value.filter(existing => existing !== numeric),
    ].slice(0, MAX_RECENT);
    LocalStorage.set(storagePath(), recentIds.value);
  };

  watch(
    currentAccountId,
    () => {
      recentIds.value = read();
    },
    { immediate: true }
  );

  return { recentIds, remember };
}
